import { Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { dateToStringLong, dateToStringShort } from "../../common/utils/dateTime";
import { formatNotaryData } from "../../common/utils/formatters";
import { AuthorizationSearchResultDto } from "../../interfaces/Authorization";
import { SearchLogPrintDto } from "../../interfaces/SearchLogPrintDto";
import { WithdrawnAuthorizationSearchResultDto } from "../../interfaces/WithdrawnAuthorization";
import authorizationService from "../../services/authorizationService";
import withdrawnAuthorizationService from "../../services/withdrawnAuthorizationService";

type SearchLogPrintProps = {
  printComponentRef: React.MutableRefObject<null>;
  refNo?: string;
  results?: Array<AuthorizationSearchResultDto> | Array<WithdrawnAuthorizationSearchResultDto>;
  isWithdrawn: boolean;
};

export default function SearchLogPrint({ printComponentRef, refNo, results, isWithdrawn }: SearchLogPrintProps) {
  const [log, setLog] = useState<SearchLogPrintDto>();

  useEffect(() => {
    if (refNo) {
      (async () => {
        isWithdrawn
          ? await withdrawnAuthorizationService.getSearchLogAsync(refNo).then(async ({ data }) => {
              setLog(data);
            })
          : await authorizationService.getSearchLogAsync(refNo).then(async ({ data }) => {
              setLog(data);
            });
      })();
    }
  }, [refNo]);

  return (
    <div style={{ display: "none" }}>
      {log && (
        <Stack spacing={3} ref={printComponentRef} sx={{ fontSize: ".8rem" }}>
          <p>
            <b>Справка № {refNo}</b>
          </p>
          <p>
            <b>{isWithdrawn ? "Оттеглени пълномощни" : "Пълномощни банки"}</b>
          </p>
          <p>
            <span>
              Нотариус: {log.notaryName}, номер {log.notaryNumber}, район на действие {log.notarySettlementName}
            </span>
          </p>
          <p>Рег. номер: {log.registrationNumber}</p>
          <p>Дата: {dateToStringShort(log.issueDate)}</p>
          <p>&nbsp;</p>

          {results && results.length > 0 ? (
            <>
              <p>
                <b>Намерени документи</b>
              </p>
              {results.map((item) => (
                <p>
                  {formatNotaryData(item.notary?.name, item.notary?.number)}, {item.registrationNumber}/
                  {dateToStringShort(item.issueDate)}
                </p>
              ))}
            </>
          ) : (
            <p>
              <b>Няма намерени документи</b>
            </p>
          )}
          <p>&nbsp;</p>
          <p>&nbsp;</p>
          <p>Дата и час на справката: {dateToStringLong(log?.logCreateDate)}</p>
          <p>
            Настоящата справка представлява извлечение от служебния архив на нотариуса, съдържащо се в базата данни на
            Информационната система на Нотариалната камара и същата служи за служебни цели.
          </p>
          <p>&copy;{new Date().getFullYear()} Нотариална камара на Република България</p>
        </Stack>
      )}
    </div>
  );
}
